import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb46a1a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "success-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success-bg-pattern" }, null, -1))
const _hoisted_3 = { class: "success-container fade-in" }
const _hoisted_4 = { class: "success-card" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Obrigado!", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "success-message" }, "A sua conta foi criada com sucesso!", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "success-details" }, " Foi enviado um email com instruções sobre como ativar a sua conta. ", -1))
const _hoisted_9 = { class: "success-actions" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-in-alt mr-2" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Área de cliente ")
const _hoisted_12 = { class: "login-link" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Já tem conta? ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Entre aqui")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            class: "button is-link is-medium",
            to: "/login"
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("p", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_router_link, {
          to: "/login",
          class: "has-text-link"
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ])
    ])
  ]))
}